import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";

const NotificationsPermissionDialog = () => {
  const [notificationsPermission, setNotificationsPermission] = useState<NotificationPermission>();

  useEffect(() => {
    Notification.requestPermission().then((res) => setNotificationsPermission(res));
  }, []);

  return (
    <Dialog open={notificationsPermission !== "granted"}>
      <DialogTitle>Please Check Notifications Permission</DialogTitle>
      <DialogContent>
        Login process cannot be done without notifications permission, which is crucial in app
        functionality.
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};

export default NotificationsPermissionDialog;
